import React, { useEffect, useState } from "react";
import styles from "./MoreInfo.module.css";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { isMobile } from "react-device-detect";
import { IsMoreInfo, CRSConsent } from "../../utils/GlobalKey";
import { getData, storeData } from "../../utils/GlobalHelper";

const MoreInfo = ( props ) => {
  const { title, details, btnText } = props;
  const [isScrollEnd, setIsScrollEnd] = useState(false);
  const isMoreInfo = getData(IsMoreInfo);

  const handleScroll = (event) => {
    const target = event.currentTarget;
    let a = target.scrollTop - target.scrollHeight;
    let b = (target.clientHeight + 10) * -1;

    if (a === b || a > b) {
      setIsScrollEnd(true);
    }
  };

  const handleNextButton = () => {
    storeData(IsMoreInfo, "false");
    storeData(CRSConsent, "true");
    // props.history.push("/otp");
  };

  const scrollToElement = (action) => {
    if (action) {
      setTimeout(() => {
        const container = document.getElementById(action);
        container?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  };
  
  return (
    <>
      <div className={isMobile ? styles.containerMobile : styles.container} onScroll={handleScroll}>
        <Typography
          className={styles.title}
        >
          {title}
        </Typography>
        <div>
          <Typography
            className={styles.details}
          >
            {details}
          </Typography>
        </div>
        <div id="end-details" style={{height: "0px"}}/>
      </div>
      {
        isScrollEnd ? (
          <div className={styles.btnContainer}>
            <Button
              id="nextPage"
              className={styles.btn}
              onClick = {handleNextButton}
            >
              <Typography className={styles.btnText}>ถัดไป</Typography>
            </Button>
          </div>
        ) 
        : (
          <div className={styles.btnContainer}>
            <Button
              id="nextPage"
              className={styles.btnScroll}
              onClick = {() => scrollToElement('end-details')}
            >
              <Typography className={styles.btnScrollText}>เลื่อนลงไปล่างสุด</Typography>
            </Button>
          </div>
        )
      }
    </>
  )
}

export default MoreInfo;